<template>
  <div class="detail-page">
    <div class="content">
      <h1>What is Net Ban Chinese Fast Assessment?</h1>
      <div class="divider"></div>
      <div class="image-box">📖</div>
      <p>NBCFA is an AI-powered academic English proficiency assessment developed by NETCLASS (Nasdaq: NTCL) and designed to evaluate real-world classroom readiness.</p>
      <p>It measures how learners comprehend lectures, engage in academic dialogue, and produce written responses within authentic English-medium instructional settings.</p>
      <p>Unlike traditional standardized tests, NBCFA focuses on actual academic performance rather than test-taking strategies, delivering fast, objective, and decision-ready results for institutions. The NBCFA scores indicate whether a learner is ready for English study.</p>
      <h2>核心优势</h2>
      <ul>
        <li>AI 驱动的自适应测评，精准评估学习者的真实语言能力</li>
        <li>场景化任务设计，模拟真实课堂环境</li>
        <li>30 分钟快速完成，高效便捷</li>
        <li>多维度能力分析报告，提供个性化学习建议</li>
        <li>国际标准认证，结果权威可信</li>
      </ul>
      <h2>测评维度</h2>
      <ul>
        <li>听力理解能力 — 能否听懂学术讲座的核心内容</li>
        <li>口语表达能力 — 能否清晰复述和表达观点</li>
        <li>学术互动能力 — 能否参与多轮学术对话</li>
        <li>阅读写作能力 — 能否理解学术文本并完成写作任务</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default { name: 'AboutDetail' }
</script>

<style scoped>
.detail-page { min-height: 100vh; background: #f7f8fc; padding-top: 24px; }
.content {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 40px 60px;
}
.divider {
  width: 48px;
  height: 3px;
  background: #2b7de9;
  margin: 16px 0 32px;
}
.image-box {
  width: 100%;
  height: 300px;
  background: linear-gradient(135deg, #e8f0fe, #d2e3fc);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 80px;
  margin-bottom: 32px;
}
h1 { font-size: 28px; font-weight: 700; color: #1a1a1a; }
h2 { font-size: 20px; font-weight: 700; color: #1a1a1a; margin: 28px 0 12px; }
p { font-size: 15px; color: #555; line-height: 1.8; margin-bottom: 12px; }
ul { padding-left: 20px; margin-bottom: 16px; }
li { font-size: 15px; color: #555; line-height: 2; }
@media (max-width: 768px) {
  .back-bar, .content { padding-left: 20px; padding-right: 20px; }
}
</style>
